"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddableVizClientLineagePanel = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const shared_urls_1 = require("@tableau/shared-urls");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const ViewDetailsByPathWrapper_1 = require("./ViewDetailsByPathWrapper");
function EmbeddableVizClientLineagePanel(props) {
    const [stackingRootElement, setStackingRootElement] = react_1.default.useState(null);
    return (react_1.default.createElement(widgets_1.StackingRootContext.Provider, { value: stackingRootElement },
        react_1.default.createElement("div", { ref: setStackingRootElement },
            react_1.default.createElement(data_catalog_shared_1.VizClientDataCatalogProvider, { telemetryVizClientApiCallback: props.telemetryVizClientApiCallback, client: props.client, siteUrls: new shared_urls_1.SiteUrls({
                    siteUrlName: props.siteUrlName,
                    queryString: props.queryString,
                }), siteLuid: props.siteLuid, featureFlags: {
                    metricsDataCatalogEnabled: false,
                    writableFieldDescriptionsEnabled: props.writableFieldDescriptionsEnabled,
                    fieldDescriptionInheritanceLineageEnabled: false,
                    publishedConnectionsLineageEnabled: true,
                    databasesInProjectsEnabled: false,
                    lensLineageEnabled: false,
                    relevantAssetsEnabled: true,
                    mixedContentConnectToDialogEnabled: true,
                    customSensitivityLabelsEnabled: false,
                    searchAndFilterOnLineagePageEnabled: false,
                    dataCloudInCatalogMVPEnabled: true,
                    customLabelCategoriesEnabled: true,
                } },
                react_1.default.createElement(data_catalog_shared_1.ReactTelemetryContext.Provider, { value: {
                        site_luid: props.siteLuid,
                        session_id: props.sessionId,
                        site_role: props.siteRole,
                    } },
                    react_1.default.createElement(ViewDetailsByPathWrapper_1.ViewDetailsByPathWrapper, { viewPath: props.sheetPath, testId: props.testId, onCloseRequested: props.onCloseRequested, lastRefreshKey: props.lastRefreshKey, vizPortalWebClientRequester: props.vizPortalWebClientRequester }))))));
}
exports.EmbeddableVizClientLineagePanel = EmbeddableVizClientLineagePanel;
//# sourceMappingURL=EmbeddableVizClientLineagePanel.js.map